export const opacity = {
  disabled: 0.45,
  muted: 0.7,
  overlay: 0.55,
  ghost: 0.12,
};
